import store from "utils/store.js";

export default function setPeriods(periods) {
  store.dispatch({
    type: "periods/set",
    payload: periods,
  });
}
